import { render, staticRenderFns } from "./pinned-products-list.component.vue?vue&type=template&id=3bd8e574"
import script from "./pinned-products-list.component.vue?vue&type=script&lang=ts"
export * from "./pinned-products-list.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports